import React from "react";
import { Route, Redirect } from "react-router-dom";
import { runsOnMobile } from "./CapacitorHelper";

export const PrivateOfflineRoute = ({ component: Component, ...rest }) => {
  // check if runs on mobile-device
  const offlineAccessPossible = runsOnMobile();
  return (
    <Route
      {...rest}
      render={(props) => {
        if (offlineAccessPossible) {
          return <Component {...props} />;
        } else {
          return (
            <Redirect
              to={{
                pathname: "/login",
                state: {
                  from: props.location,
                },
              }}
            />
          );
        }
      }}
    />
  );
};
